export default __webpack_public_path__ + "static/media/my-photo.296e15e3.png";